const STORAGE_KEY = "auth_data";

export function storeAuth(data) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    // Private browsing and blocked site data can both throw here. Losing the
    // "stay signed in" convenience is survivable; crashing the app is not.
  }
}

export function retrieveAuth() {
  try {
    const asString = window.localStorage.getItem(STORAGE_KEY);
    return asString ? JSON.parse(asString) : undefined;
  } catch (e) {
    return undefined;
  }
}

export function removeAuth() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // See storeAuth.
  }
}

export function getToken() {
  const auth = retrieveAuth();
  return auth && auth.token && auth.token.token;
}

export function isExpired(auth) {
  if (!auth || !auth.token || !auth.token.expires) return true;
  return new Date() > new Date(auth.token.expires);
}
